/* AKKA HOME — Personalised Image: inline controller
   Pairs with snippets/akka-personal-tile-inline.liquid (rendered as a block in
   the buy box, between quantity and Add to Cart) and akka-tile-preview.js.

   · The mockup is drawn on a canvas that OVERLAYS the product media gallery,
     so the preview appears in the existing image area, above the fold.
   · The file input is form-associated with the product form (form= attribute),
     so the photo submits with Add to Cart — including Dawn's AJAX add — and
     lands on the order as the "Reference image" line-item property.
   · An optional written brief submits as the "Motif description" property.
   · Colour + Corner Style follow the native variant radios, whether clicked
     directly or via the Studio Letter custom picker (which clicks the radios).
*/
(function () {
  'use strict';

  var CAPTION = 'A mockup, for visualisation only — our artist redraws your photo by hand, and you approve the artwork before it’s painted.';

  function init(rootEl) {
    rootEl.dataset.booted = '1';

    var errEl = document.getElementById('AkkaPtErr');
    var fileInput = document.getElementById('AkkaPtFile');   /* carries the photo on the order */
    var picker = document.getElementById('AkkaPtPicker');    /* scratch input the button opens */
    var descEl = document.getElementById('AkkaPtDesc');      /* optional written brief */
    var maxBytes = (parseInt(rootEl.dataset.maxMb, 10) || 20) * 1024 * 1024;

    var state = { photo: null, colour: 'Dutch', corner: 'Delft', detail: 0.55, wash: true, removeBg: false, bgTol: 0.5, zoom: 1, ox: 0, oy: 0, motifFrac: 0.55 };
    var bases = null, motifCache = null, motifDirty = true;
    var overlay = null, canvas = null, showChip = null;

    function load(src) {
      return new Promise(function (res, rej) {
        var i = new Image();
        i.crossOrigin = 'anonymous';
        i.onload = function () { res(i); };
        i.onerror = rej;
        i.src = src;
      });
    }

    /* ---------- gallery overlay ---------- */
    function galleryHost() {
      return document.querySelector('.product__media-wrapper media-gallery') ||
             document.querySelector('media-gallery') ||
             document.querySelector('.product__media-wrapper');
    }
    function ensureOverlay() {
      if (overlay && document.body.contains(overlay)) return overlay;
      var host = galleryHost();
      if (!host) return null;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      overlay = document.createElement('div');
      overlay.className = 'akka-pt-overlay';
      canvas = document.createElement('canvas');
      canvas.width = 1100; canvas.height = 1100;
      canvas.setAttribute('aria-label', 'Live tile mockup of your photo');
      var badge = document.createElement('span');
      badge.className = 'akka-pt-badge';
      badge.textContent = 'Your tile — mockup';
      var close = document.createElement('button');
      close.className = 'akka-pt-close';
      close.type = 'button';
      close.setAttribute('aria-label', 'Hide the mockup and show product photos');
      close.textContent = '×';
      close.addEventListener('click', hideOverlay);
      var cap = document.createElement('p');
      cap.className = 'akka-pt-cap';
      cap.textContent = CAPTION;
      overlay.appendChild(canvas);
      overlay.appendChild(badge);
      overlay.appendChild(close);
      overlay.appendChild(cap);
      host.appendChild(overlay);
      /* chip that brings the mockup back after it's been closed */
      showChip = document.createElement('button');
      showChip.className = 'akka-pt-showchip';
      showChip.type = 'button';
      showChip.textContent = 'Show tile mockup';
      showChip.addEventListener('click', showOverlay);
      host.appendChild(showChip);
      return overlay;
    }
    function showOverlay() {
      var ov = ensureOverlay();
      if (!ov) return;
      ov.classList.add('on');
      if (showChip) showChip.classList.remove('on');
    }
    function hideOverlay() {
      if (overlay) overlay.classList.remove('on');
      if (showChip && state.photo) showChip.classList.add('on');
    }

    /* ---------- bind to the main product form ---------- */
    function productForm() {
      /* data-type is required — Dawn's Shop Pay installments form also posts
         to /cart/add and would otherwise match first. */
      return document.querySelector('product-info form[data-type="add-to-cart-form"]') ||
             document.querySelector('form[data-type="add-to-cart-form"]');
    }
    function bindForm() {
      var form = productForm();
      if (!form) return;
      /* NB: form.id is unreliable here — Dawn's product form contains an
         <input name="id"> which shadows the element's id property. */
      var fid = form.getAttribute('id');
      if (!fid) { fid = 'akka-product-form'; form.setAttribute('id', fid); }
      if (fileInput.getAttribute('form') !== fid) fileInput.setAttribute('form', fid);
      if (descEl && descEl.getAttribute('form') !== fid) descEl.setAttribute('form', fid);
      if (form.getAttribute('enctype') !== 'multipart/form-data') form.setAttribute('enctype', 'multipart/form-data');
    }
    bindForm();
    new MutationObserver(bindForm).observe(document.body, { childList: true, subtree: true });

    /* Optional written brief: only carries a name (and therefore submits)
       while it holds text — an empty box never creates a blank property. */
    if (descEl) {
      descEl.addEventListener('input', function () {
        if (descEl.value.trim().length > 0) descEl.setAttribute('name', 'properties[Motif description]');
        else descEl.removeAttribute('name');
      });
    }

    /* ---------- variant sync (Colour / Corner Style) ---------- */
    function readVariants() {
      var changed = false;
      document.querySelectorAll('.product-form__input input[type=radio]:checked').forEach(function (r) {
        var v = r.value;
        if (window.AkkaTilePreview.COLOURWAYS[v] && v !== state.colour) { state.colour = v; changed = true; }
        if ((v === 'Delft' || v === 'Blank') && v !== state.corner) { state.corner = v; changed = true; }
      });
      return changed;
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.product-form__input input[type=radio]')) {
        if (readVariants() && state.photo) { motifDirty = true; render(); showOverlay(); }
      }
    });

    /* ---------- rendering ---------- */
    function cropCanvas() {
      var img = state.photo, S = 560;
      var c = document.createElement('canvas'); c.width = c.height = S;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      var cover = Math.max(S / img.width, S / img.height) * state.zoom;
      var vw = S / cover, vh = S / cover;
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, S, S);
      ctx.drawImage(img, (img.width - vw) / 2 + state.ox, (img.height - vh) / 2 + state.oy, vw, vh, 0, 0, S, S);
      return c;
    }
    var renderQueued = false;
    function render() {
      if (!bases || renderQueued || !state.photo) return;
      if (!ensureOverlay()) return;
      renderQueued = true;
      requestAnimationFrame(function () { setTimeout(function () {
        renderQueued = false;
        var base = state.corner === 'Delft' ? bases.corner[state.colour] : bases.blank;
        if (motifDirty || !motifCache) {
          motifCache = window.AkkaTilePreview.renderMotif(cropCanvas(), { colour: state.colour, detail: state.detail, wash: state.wash, removeBg: state.removeBg, bgTol: state.bgTol });
          motifDirty = false;
        }
        window.AkkaTilePreview.compose(canvas, base, motifCache, { motifFrac: state.motifFrac });
      }, 10); });
    }

    /* ---------- photo intake ---------- */
    function showErr(msg) { errEl.textContent = msg; errEl.hidden = false; }
    function clearErr() { errEl.hidden = true; }
    function setPhoto(img) {
      state.photo = img; state.zoom = 1; state.ox = 0; state.oy = 0;
      motifDirty = true;
      render();
      showOverlay();
    }
    /* Copy a file into the order-bound input so it submits with Add to Cart.
       If DataTransfer isn't constructible (old Safari), promote the picker
       itself to be the order input instead. */
    function syncToOrderInput(file, sourceInput) {
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        fileInput.files = dt.files;
      } catch (err) {
        if (sourceInput && sourceInput !== fileInput) {
          fileInput.removeAttribute('name');
          sourceInput.setAttribute('name', 'properties[Reference image]');
          fileInput = sourceInput;
          bindForm();
        }
      }
    }
    function fromFile(file, sourceInput) {
      clearErr();
      if (file.size > maxBytes) {
        picker.value = '';
        fileInput.value = '';
        showErr('That photo is over ' + Math.round(maxBytes / 1048576) + 'MB — a smaller export will upload happily.');
        return;
      }
      syncToOrderInput(file, sourceInput);
      document.getElementById('AkkaPtFileRow').hidden = false;
      document.getElementById('AkkaPtFileName').textContent = file.name;
      var url = URL.createObjectURL(file);
      load(url).then(function (img) { setPhoto(img); URL.revokeObjectURL(url); })
        .catch(function () {
          URL.revokeObjectURL(url);
          /* HEIC on non-Safari: no preview, but the file still attaches. */
          showErr('We can’t preview this format in your browser, but your photo will still travel with the order. For a live mockup, try a JPG or PNG.');
        });
    }
    var drop = document.getElementById('AkkaPtDrop');
    function pick() {
      /* Clear the scratch input first so `change` fires even when the same
         file is picked again (browsers skip the event if value is unchanged
         — this was why re-uploading after closing the mockup went dead). */
      if (picker !== fileInput) picker.value = '';
      picker.click();
    }
    drop.addEventListener('click', pick);
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    document.getElementById('AkkaPtReplace').addEventListener('click', pick);
    picker.addEventListener('change', function () { if (picker.files[0]) fromFile(picker.files[0], picker); });
    ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); }); });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer.files[0]) fromFile(e.dataTransfer.files[0], null);
    });

    /* ---------- base photography ---------- */
    Promise.all([
      load(rootEl.dataset.baseBlank),
      load(rootEl.dataset.baseDutch),
      load(rootEl.dataset.basePotters),
      load(rootEl.dataset.baseNe)
    ]).then(function (imgs) {
      bases = { blank: imgs[0], corner: { 'Dutch': imgs[1], 'Potters': imgs[2], 'New England': imgs[3] } };
      readVariants();
      render();
    }).catch(function () {
      showErr('Mockup images failed to load — the upload still works and your photo will travel with the order.');
    });
  }

  /* Boot — and re-boot if the theme re-renders the buy box. */
  function tryInit() {
    var rootEl = document.getElementById('AkkaPersonalTile');
    if (rootEl && !rootEl.dataset.booted && window.AkkaTilePreview) init(rootEl);
  }
  if (document.readyState !== 'loading') tryInit();
  else document.addEventListener('DOMContentLoaded', tryInit);
  new MutationObserver(tryInit).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', tryInit);
})();
